import { Logger } from '@utils/logger/logger';

let enabled: boolean | null = null;

/**
 * Mirrors the native tracker's `?debugImpressions=true` flag so the redux
 * impression queue can be traced from the browser console during QA.
 */
const isDebugEnabled = (): boolean => {
	if (enabled === null) {
		enabled =
			typeof window !== 'undefined' &&
			new URLSearchParams(window.location.search).get('debugImpressions') ===
				'true';
	}
	return enabled;
};

export const debugImpressionLog = (
	message: string,
	data?: Record<string, unknown>,
): void => {
	if (isDebugEnabled()) {
		Logger.log({
			log_message: `[vendorImpressions] ${message}${
				data ? ` ${JSON.stringify(data)}` : ''
			}`,
		});
	}
};
